import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, ViewChildren, QueryList} from '@angular/core'
import { CRMDocumentModel } from '../../Models/CRMDocumentModel';
import { DocumentConfiguration } from '../../Models/DocumentConfiguration';
import { DocumentModel } from '../../Models/DocumentModel';
import { ResponseMessageCode } from '../../../enums/response-message-code';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ResultDetails } from '../../../models/result-details';
import { Language } from '../../../enums/language.enum';
import { CommonService } from '../../../services/common-service/common.service';
import { debug } from 'util';

@Component({
  selector: 'app-crmserviceattachmentuploader',
  templateUrl: './crmserviceattachmentuploader.component.html',
  styleUrls: ['./crmserviceattachmentuploader.component.css']
})
export class CrmuploaderServiceAttachmentComponent implements OnInit, AfterViewInit{
  @ViewChildren('Uploaders') Uploaders: QueryList<any>;
  DocumentsConfiguration: CRMDocumentModel[];
  ValidationsConfiguration: Array<DocumentConfiguration>;
  attachments: Array<DocumentModel>;
  finalAttachments: Array<Array<DocumentModel>>;
  attachmentValidations: Array<boolean>;
  isUploaderReady: boolean;
  languagtEnum = Language;
  constructor(private http: HttpClient, protected commonService: CommonService) {
    this.isUploaderReady = false;
    this.ValidationsConfiguration = new Array<DocumentConfiguration>();
    this.attachments = new Array<DocumentModel>();
    this.finalAttachments = new Array<Array<DocumentModel>>();
    this.attachmentValidations = new Array<boolean>();

  }
  @Input('serviceId') serviceId: string;
  @Input('requestId') requestId: string;
  @Input('resources') resources: any;
  @Input('isEditable') isEditable: boolean;
  @Input('language') language: Language = Language.English;
  @Input('isSubmitted') isSubmitted: boolean;
  @Output() IsValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  isCRM: boolean = true;
  isHideDownload: boolean = true;
  ngOnInit() {
    this.commonService.showLoader();
    this.getRequestConfiguration(this.serviceId, this.requestId);
   
  }
  ngAfterViewInit(): void {
    this.Uploaders.changes.subscribe(t => {
      this.commonService.hideLoader();
    })
  } 
  IsAttachmentIdVaild(event, i) {
    if (this.attachmentValidations.length > 0) {
      //debugger;
      this.attachmentValidations[i] = event;
      this.IsValid.emit(this.attachmentValidations.indexOf(false) >= 0 ? false : true);
    }
    else {
      this.IsValid.emit(true);
    }
  }
  protected getRequestConfiguration(serviceId?: string, requestId?: string): void {
    //debugger;
    this.http.get<ResultDetails>(environment.document_crmGetServiceDocumentConfiguration + "?Serviceid=" + serviceId).subscribe(result => {
      if (result.IsSucceeded) {
       // this.DocumentsConfiguration = result.Data.Result;
        if (result.Data.Result) {
          this.DocumentsConfiguration = result.Data.Result.sort(function (x, y) {
            // true values first
            return (x.IsMandatory === y.IsMandatory) ? 0 : x.IsMandatory ? -1 : 1;
            // false values first
            // return (x === y)? 0 : x? 1 : -1;
          });
        }
        this.setValidationsCofiguratios(this.DocumentsConfiguration);
        this.isUploaderReady = true;
      }
      else {
        if (result.MessageCode == ResponseMessageCode.Error) {
        }
        
      }
    }, error => {
    });
  }
  setValidationsCofiguratios(crmdocuments: CRMDocumentModel[]) {
    var self = this; 
    for (var i = 0; i < crmdocuments.length; i++) {
      let AllowedExtetion: string[];
      if (crmdocuments[i].AllowedExtensions) {
         AllowedExtetion = crmdocuments[i].AllowedExtensions.replace(" ", "").split(",").map(item => {
          return "." + item;
        });
      }
      let documentconfig: DocumentConfiguration = {
        AllowedSize: crmdocuments[i].MaximunAllowedSizeMB * 1000000,
        AllowedExtension: AllowedExtetion? AllowedExtetion.join(","):".*",
        Name: "CRMDocument"+i,
        Key: 0
      }
      let documentModel: DocumentModel = {
        TempId :crmdocuments[i].UploadedDocumentID,
        RealId : crmdocuments[i].UploadedDocumentID,
        IsDeleted : false,
        Size: crmdocuments[i].UploadedDocSize * 1000000,
        RequestId: this.requestId,
        extension: crmdocuments[i].UploadedDocExtension,
        mimeType: "",
        Name: crmdocuments[i].UploadedDocName,
        SizeToShow: (crmdocuments[i].UploadedDocSize * 1000000).toString() 
      }
      self.ValidationsConfiguration.push(documentconfig);
      let DocumentArray: Array<DocumentModel> = new Array<DocumentModel>();
      DocumentArray.push(documentModel);
      if (crmdocuments[i].UploadedDocumentID && crmdocuments[i].UploadedDocumentID != "00000000-0000-0000-0000-000000000000") {
        self.finalAttachments.push(DocumentArray);
        self.attachmentValidations.push(true);
      } else {
        self.finalAttachments.push(null);
        self.attachmentValidations.push(false);
      }
    }
    return true;
  }
}
